// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ox-1";
export var messageSideRight = "_ox-2";
export var orderLookupBubbleContainer = "_ox-0";
export var submitButton = "_ox-3";